import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Bruce Taylor",
        title: "Founder & CEO",
        biography: "Bruce Taylor is the visionary founder behind DriveEase Rentals. With years of expertise in the automotive and rental industry, he has shaped the company into a trusted name known for quality vehicles and seamless customer service.",
        contacts: {
            phone: "555-123-7890",
            email: "bruce.t@driveease.com",
            website: "www.driveease.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Fleet Management",
            "Business Development",
            "Customer Satisfaction",
            "Strategic Growth",
            "Operational Efficiency"
        ],
        skills: [
            { id: 1, title: "Fleet Operations", progress: 97 },
            { id: 2, title: "Business Leadership", progress: 93 },
            { id: 3, title: "Client Relations", progress: 91 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Shirley Cowles",
        title: "Manager",
        biography: "Shirley Cowles oversees daily operations at DriveEase Rentals, ensuring smooth coordination between customers, fleet, and service teams. Her attention to detail and dedication make her a cornerstone of our exceptional rental experience.",
        contacts: {
            phone: "555-456-3210",
            email: "shirley.c@driveease.com",
            website: "www.driveease.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Team Coordination",
            "Customer Service Management",
            "Vehicle Scheduling",
            "Staff Supervision",
            "Operational Support"
        ],
        skills: [
            { id: 1, title: "Operations Management", progress: 92 },
            { id: 2, title: "Customer Service", progress: 94 },
            { id: 3, title: "Problem Solving", progress: 90 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Richard Collinge",
        title: "Director",
        biography: "Richard Collinge brings strategic vision and leadership to DriveEase Rentals. As Director, he focuses on long-term planning, partnerships, and innovation to ensure the company stays ahead in the competitive car rental market.",
        contacts: {
            phone: "555-789-1122",
            email: "richard.c@driveease.com",
            website: "www.driveease.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Corporate Strategy",
            "Business Partnerships",
            "Market Expansion",
            "Brand Development",
            "Leadership & Mentoring"
        ],
        skills: [
            { id: 1, title: "Strategic Planning", progress: 96 },
            { id: 2, title: "Leadership", progress: 94 },
            { id: 3, title: "Industry Insight", progress: 92 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Jill Saulbrey",
        title: "Sales Manager",
        biography: "Jill Saulbrey leads the sales team at DriveEase Rentals with a strong focus on customer engagement and conversion. Her deep knowledge of rental plans and client needs ensures our customers get the best deals with maximum value.",
        contacts: {
            phone: "555-334-8899",
            email: "jill.s@driveease.com",
            website: "www.driveease.com"
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            "Sales Strategy",
            "Client Acquisition",
            "Revenue Optimization",
            "CRM Management",
            "Team Coaching"
        ],
        skills: [
            { id: 1, title: "Sales Planning", progress: 93 },
            { id: 2, title: "Customer Engagement", progress: 95 },
            { id: 3, title: "Negotiation", progress: 90 }
        ]
    }

];

export default team;